import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { TabBar } from '@inmoment/the-kitchen';
import { KitchenThemeContext } from '../../App';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Example', 'Suggestion Data', 'ErrorObject', 'ErrorStates'].map(convertArrayToTabBar);

export const SearchBoxDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('Example');
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <>
      <div>
        <p className="kxi-text-300 kxi-text-normal">SearchBox Usage Notes</p>
        <br />
        <p className="kxi-text-small kxi-text-300">
          When `hasOutline` is set, this component <b>requires a 2px overflowable area</b> around the component. This allows the border to have the
          full room to expand when active. If the proper overflowable area is not available, the border when active will appear to be cut off.
        </p>
        <br />
        <br />
      </div>
      <div>
        <p className="kxi-text-300 kxi-text-normal">SearchBox Status</p>
        <br />
        <div style={{ height: 46 }}>
          <TabBar stretch data={data1} color={theme} onTabChange={({ tab }) => setTab(tab!.title)} />
        </div>
        {tab === 'Suggestion Data' && (
          <CodeBlock
            hasTopRadius={false}
            code={`[
  {
    text: 'Suggestion 1';
  },
  {
    text: 'Suggestion 2';
  },
  {
    text: 'Suggestion 3';
  }
]`}
          />
        )}
        {tab === 'Example' && (
          <CodeBlock
            hasTopRadius={false}
            code={`{
  state: 'error';
  text: 'Oh no!';
}`}
          />
        )}
        {tab === 'ErrorObject' && (
          <CodeBlock
            hasTopRadius={false}
            code={`export interface ErrorObject {
  state: ErrorStates;
  text?: string;
}`}
          />
        )}
        {tab === 'ErrorStates' && <CodeBlock hasTopRadius={false} code="export type ErrorStates = 'success' | 'warning' | 'error';" />}

        <br />
      </div>
    </>
  );
};
